/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { co_getplato_grid_api_domain_NormalDraftOrderLineItem } from './co_getplato_grid_api_domain_NormalDraftOrderLineItem';
import type { co_getplato_grid_api_domain_NoteDraftOrderLineItem } from './co_getplato_grid_api_domain_NoteDraftOrderLineItem';
export type co_getplato_grid_api_domain_DraftOrderLineItem = {
    line_item_id: string;
    type: co_getplato_grid_api_domain_DraftOrderLineItem.type;
    normal_line_item?: co_getplato_grid_api_domain_NormalDraftOrderLineItem;
    note_line_item?: co_getplato_grid_api_domain_NoteDraftOrderLineItem;
    external: Record<string, any>;
};
export namespace co_getplato_grid_api_domain_DraftOrderLineItem {
    export enum type {
        NORMAL = 'NORMAL',
        NOTE = 'NOTE',
    }
}

